import { Redirect, Route, RouteProps } from 'react-router';
import React, { useEffect, useRef } from 'react';
import Authentication from './services/authentication';
import { useSelector } from 'react-redux';
import { UserType } from './stores/authenticated';
import { AppState } from './stores';
import { authSessionLog } from './services/auth-session-logger';
import { useProtectedRouteSession } from './hooks/useProtectedRouteSession';

const AdminRoute: React.FC<RouteProps> = (props) => {
  const user = useSelector((state: AppState) => state.authenticated.user as UserType);
  const accessTokenExpiresAt = useSelector(
    (state: AppState) => state.authenticated.accessTokenExpiresAt,
  );
  const sessionStatus = useProtectedRouteSession('AdminRoute');
  const authentication = new Authentication();
  const lastLoggedAdminDeniedRef = useRef(false);

  const isAdmin = () => {
    return authentication.isAdminValid(accessTokenExpiresAt, user);
  };

  useEffect(() => {
    if (sessionStatus === 'allowed' && !isAdmin() && !lastLoggedAdminDeniedRef.current) {
      authSessionLog({
        level: 'warn',
        event: 'soft_logout',
        reason: 'admin',
        trigger: 'AdminRoute',
        detail: 'user lacks admin role for system-manager route',
      });
      lastLoggedAdminDeniedRef.current = true;
    }
    if (sessionStatus === 'allowed' && isAdmin()) {
      lastLoggedAdminDeniedRef.current = false;
    }
  }, [sessionStatus, accessTokenExpiresAt, user]);

  return (
    <Route
      render={(innerProps) => {
        if (sessionStatus === 'checking') {
          return null;
        }
        if (sessionStatus === 'denied' || !isAdmin()) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: innerProps.location },
              }}
            />
          );
        }
        return <Route {...props} />;
      }}
    />
  );
};

export default AdminRoute;
